(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skarpast-brand-directory"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-brand-directory]').forEach((directory) => {
    const areaButtons = Array.from(directory.querySelectorAll('[data-brand-area]'));
    const letterButtons = Array.from(directory.querySelectorAll('[data-brand-letter]'));
    const groups = Array.from(directory.querySelectorAll('[data-brand-group]'));
    const items = Array.from(directory.querySelectorAll('[data-brand-item]'));
    const emptyState = directory.querySelector('.sk-brand-directory__empty');
    let activeArea = 'all';
    let activeLetter = '';

    const update = () => {
      let visibleCount = 0;
      groups.forEach((group) => {
        const areaMatches = activeArea === 'all' || group.dataset.brandGroup === activeArea;
        let groupCount = 0;
        group.querySelectorAll('[data-brand-item]').forEach((item) => {
          const letterMatches = !activeLetter || item.dataset.brandLetterValue === activeLetter;
          item.hidden = !(areaMatches && letterMatches);
          if (!item.hidden) groupCount += 1;
        });
        group.hidden = groupCount === 0;
        visibleCount += groupCount;
      });
      emptyState.hidden = visibleCount !== 0;
    };

    areaButtons.forEach((button) => button.addEventListener('click', () => {
      activeArea = button.dataset.brandArea;
      areaButtons.forEach((candidate) => {
        const selected = candidate === button;
        candidate.classList.toggle('is-active', selected);
        candidate.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      update();
    }));

    letterButtons.forEach((button) => button.addEventListener('click', () => {
      activeLetter = activeLetter === button.dataset.brandLetter ? '' : button.dataset.brandLetter;
      letterButtons.forEach((candidate) => candidate.setAttribute('aria-pressed', candidate.dataset.brandLetter === activeLetter ? 'true' : 'false'));
      update();
      const firstVisible = items.find((item) => !item.hidden);
      if (firstVisible) firstVisible.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
    }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skarpast-product-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sk-product-tabs')) {
    customElements.define(
      'sk-product-tabs',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.ready === 'true') return;

          this.buttons = Array.from(this.querySelectorAll('[data-tab-button]'));
          this.items = Array.from(this.querySelectorAll('[data-tab-item]'));
          this.media = window.matchMedia('(min-width: 750px)');
          this.handleModeChange = this.syncMode.bind(this);

          this.buttons.forEach((button, index) => {
            button.addEventListener('click', () => this.activate(button, false));
            button.addEventListener('keydown', (event) => this.handleKeydown(event, index));
          });

          this.media.addEventListener('change', this.handleModeChange);
          this.dataset.ready = 'true';
          this.syncMode();
        }

        syncMode() {
          if (!this.media.matches) {
            this.items.forEach((item) => item.removeAttribute('hidden'));
            return;
          }

          const selected = this.buttons.find((button) => button.getAttribute('aria-selected') === 'true') || this.buttons[0];
          if (selected) this.activate(selected, false);
        }

        activate(button, focusButton) {
          const target = button.dataset.tabButton;

          this.buttons.forEach((candidate) => {
            const isActive = candidate === button;
            candidate.setAttribute('aria-selected', String(isActive));
            candidate.tabIndex = isActive ? 0 : -1;
          });

          this.items.forEach((item) => {
            const isActive = item.dataset.tabItem === target;
            item.toggleAttribute('hidden', !isActive);
            if (isActive) item.open = true;
          });

          if (focusButton) button.focus();
        }

        handleKeydown(event, currentIndex) {
          const keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
          if (!keys.includes(event.key)) return;

          event.preventDefault();
          let nextIndex = currentIndex;
          if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.buttons.length) % this.buttons.length;
          if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.buttons.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = this.buttons.length - 1;
          this.activate(this.buttons[nextIndex], true);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
